import React, { useState } from 'react';
import { Star, Send, Loader2, MessageCircle } from 'lucide-react';
import { Textarea } from '../ui/textarea';

export function FeedbackSection({ professional, user, onFeedbackSubmit }) {
  const [showForm, setShowForm] = useState(false);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
    setSubmitting(true);
    try {
      await onFeedbackSubmit(rating, comment);
      setSuccess(true);
      setShowForm(false);
      setComment('');
    } catch (_) {
      // handled by parent
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card-theraflow p-8" data-testid="feedbacks-section">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-medium text-[#292927]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Avaliações
        </h2>
        {user && !showForm && (
          <button onClick={() => setShowForm(true)} className="btn-secondary text-sm py-2" data-testid="add-feedback-button">
            <MessageCircle className="w-4 h-4 mr-2" strokeWidth={1.5} /> Avaliar
          </button>
        )}
      </div>

      {success && (
        <div className="mb-6 p-4 rounded-xl bg-[#6B8E7C]/10 text-[#6B8E7C] text-sm">
          Avaliação enviada com sucesso!
        </div>
      )}

      {showForm && user && (
        <form onSubmit={handleSubmit} className="mb-8 p-6 bg-[#F6EBE6]/50 rounded-2xl" data-testid="feedback-form">
          <div className="mb-4">
            <label className="block text-sm font-medium text-[#292927] mb-2">Sua avaliação</label>
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((s) => (
                <button key={s} type="button" onClick={() => setRating(s)} className="p-1">
                  <Star className={`w-8 h-8 transition-colors ${s <= rating ? 'text-[#D4A373] fill-[#D4A373]' : 'text-[#EAE8E3]'}`} strokeWidth={1.5} />
                </button>
              ))}
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-[#292927] mb-2">Comentário (opcional)</label>
            <Textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Compartilhe sua experiência..." className="input-theraflow min-h-[100px]" data-testid="feedback-comment-input" />
          </div>
          <div className="flex gap-3">
            <button type="submit" disabled={submitting} className="btn-primary flex items-center gap-2" data-testid="submit-feedback-button">
              {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4" strokeWidth={1.5} /> Enviar</>}
            </button>
            <button type="button" onClick={() => setShowForm(false)} className="btn-secondary">Cancelar</button>
          </div>
        </form>
      )}

      {professional.feedbacks?.length > 0 ? (
        <div className="space-y-6">
          {professional.feedbacks.map((fb, idx) => (
            <div key={fb.created_at || idx} className="pb-6 border-b border-[#EAE8E3] last:border-0 last:pb-0">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-[#F6EBE6] flex items-center justify-center">
                  <span className="text-sm font-medium text-[#4A5D4E]">{fb.user_name?.charAt(0) || 'U'}</span>
                </div>
                <div>
                  <p className="font-medium text-[#292927]">{fb.user_name || 'Usuário'}</p>
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={`r-${i}`} className={`w-3 h-3 ${i < fb.rating ? 'text-[#D4A373] fill-[#D4A373]' : 'text-[#EAE8E3]'}`} strokeWidth={1.5} />
                    ))}
                  </div>
                </div>
              </div>
              {fb.comment && <p className="text-[#63635E] text-sm">{fb.comment}</p>}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-[#A0A09A] text-center py-8">Nenhuma avaliação ainda. Seja o primeiro!</p>
      )}
    </div>
  );
}
